import React, { useCallback } from 'react';
import { Box, Button, Flex, Text } from 'roo-ui/components';
import PropTypes from 'prop-types';
import BookingKnowBeforeYouGo from 'pages/BookingConfirmation/BookingKnowBeforeYouGo';
import BookingOverview from './BookingOverview';
import StaySummary from './StaySummary';
import { useDataLayer } from 'hooks/useDataLayer';
import { QH_SELF_SERVICE_URL } from 'config';

const BookingSummary = ({ bookingId, knowBeforeYouGoRef }) => {
  const { emitInteractionEvent } = useDataLayer();
  const handleManageBookingClicked = useCallback(() => {
    emitInteractionEvent({ type: 'Manage Your Booking Button', value: 'Button Selected' });
  }, [emitInteractionEvent]);

  const manageBookingUrl = `${QH_SELF_SERVICE_URL}/${bookingId}?source=hotels-booking-confirmation`;

  return (
    <Flex flexDirection="column" width={1}>
      <BookingOverview />
      <StaySummary />
      <BookingKnowBeforeYouGo knowBeforeYouGoRef={knowBeforeYouGoRef} />

      <Box data-print-style="hidden">
        <Button
          as="a"
          data-testid="manage-your-booking"
          href={manageBookingUrl}
          variant="primary"
          width={['100%', 'inherit']}
          onClick={handleManageBookingClicked}
          target="_blank"
          aria-label="Manage your booking (opens in a new tab)"
        >
          <Text fontSize={['sm', 'base']} fontWeight="bold">
            Manage your booking
          </Text>
        </Button>
      </Box>
    </Flex>
  );
};

BookingSummary.displayName = 'BookingSummary';

BookingSummary.propTypes = {
  bookingId: PropTypes.string.isRequired,
  knowBeforeYouGoRef: PropTypes.shape({
    current: PropTypes.shape({
      offsetTop: PropTypes.number,
    }),
  }),
};

BookingSummary.defaultProps = {
  knowBeforeYouGoRef: {},
};

export default BookingSummary;
